import React, { Fragment, useEffect, useState } from 'react';
import { Row, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Select from 'react-select';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { API_MEETING_ROOMS, API_SpaceAddons } from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';
function AddOnForm({ propertyId, locale, visible, toggle, formLabel, id }) {
    const [selectedOptions, setselectedOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [addonsData, setAddonsData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        category: "0",
        itemName: "",
        price: 0,
        displayOrder: 0,
        spaceApplicability: [],
        status: "Active"
    });
    const [spaceList, setSpaceList] = useState([]);
    useEffect(() => {
        var spaceoption = [{ label: 'Select All', value: '-1', key: -1, }];
        AxiosAPI({
            method: 'get',
            url: `${API_MEETING_ROOMS}/all/${propertyId}`,
        }).then((result) => {
            console.log(result.data);
            if (result.data !== undefined && result.data.length > 0) {
                result.data.map((m, i) =>
                    spaceoption.push({
                        label: m.name,
                        value: m.id,
                        key: i
                    }))
            }
            setSpaceList(spaceoption);
        });
        if (id !== undefined) {
            AxiosAPI({
                methhod: 'get',
                url: `${API_SpaceAddons}/get/${id}`,
            })
                .then((res) => {
                    setAddonsData(res.data);
                    var selectedspace = [];
                    if (res.data.spaceApplicability != null && res.data.spaceApplicability.length > 0) {
                        res.data.spaceApplicability.map((item, i) => {
                            selectedspace.push(spaceoption.filter((cat) => cat.value === item)[0]);
                        });
                    }
                    setselectedOptions(selectedspace);
                })
                .catch((err) => console.log('err', err));
        }

    }, [id]);
    const handleChange = (e) => {
        setAddonsData({
            ...addonsData,
            [e.target.name]: e.target.value,
        });
    }
    const handleChangeItemName = (e) => {
        if (addonsData.itemName.length > 0) {
            const index = addonsData.itemName.findIndex((m) => m.languageCode === locale);
            if (index === -1) {
                const newStatement = {
                    statement: e.target.value,
                    languageCode: locale,
                };
                setAddonsData({
                    ...addonsData,
                    itemName: [...addonsData.itemName, newStatement],
                });
            } else {
                let newArr = [...addonsData.itemName];
                newArr[index].statement = e.target.value;
                setAddonsData({
                    ...addonsData,
                    itemName: newArr,
                });
            }
        } else {
            const newStatement = {
                statement: e.target.value,
                languageCode: locale,
            };
            setAddonsData({
                ...addonsData,
                itemName: [...addonsData.itemName, newStatement],
            });
        }
    }
    const handleSubmit = () => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'put',
                url: `${API_SpaceAddons}/update/${id}`,
                data: addonsData,
            })
                .then((res) => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                })
                .catch((err) => {
                    console.log('err', err);
                });
        }
        else {
            AxiosAPI({
                method: 'post',
                url: `${API_SpaceAddons}/create`,
                data: addonsData,
            })
                .then((res) => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                })
                .catch((err) => {
                    console.log('err', err);
                });
        }
    }
    const handleChangeMulti = (selectedOptions) => {
        if (selectedOptions.filter(i => i.value === "-1").length > 0) {
            var list = spaceList.filter(i => i.value !== "-1");
            setselectedOptions(list);
            const suitabilityArr = list.map((elem) => elem.value);
            setAddonsData({
                ...addonsData,
                spaceApplicability: suitabilityArr,
            });
        }
        else {
            setselectedOptions(selectedOptions);
            const suitabilityArr = selectedOptions.map((elem) => elem.value);
            setAddonsData({
                ...addonsData,
                spaceApplicability: suitabilityArr,
            });
        }
    };
    const getLocalStatement = (statements) => {
        if (statements !== undefined && statements.length > 0) {
            const index = statements.findIndex((m) => m.languageCode === locale);
            if (index === -1) {
                const englishIndex = statements.findIndex(
                    (m) => m.languageCode === 'en'
                );
                if (englishIndex !== -1) {
                    return statements[englishIndex].statement;
                }
            } else {
                return statements[index].statement;
            }
        } else {
            return '';
        }
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="md">
                <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
                <ModalBody>
                    <Row className="">
                        <Colxx sm={12} className="mb-3">
                            <Label>Item Name</Label>
                            <Input
                                type="text"
                                value={getLocalStatement(addonsData.itemName)}
                                onChange={handleChangeItemName}
                                name="itemName"
                            />
                        </Colxx>
                        <Colxx sm={12} className="mb-3">
                            <Label>Category</Label>
                            <Input
                                type="select"
                                value={addonsData.category}
                                name="category"
                                onChange={handleChange}
                            >
                                <option value="0">Select</option>
                                <option value="CateringServices">Catering Services</option>
                                <option value="MeetingEquipment">Meeting Equipment</option>
                            </Input>
                        </Colxx>
                        <Colxx sm={12} className="mb-3">
                            <Label>Price</Label>
                            <Input
                                type="number"
                                value={addonsData.price}
                                onChange={handleChange}
                                name="price"
                            />
                        </Colxx>
                        <Colxx sm={12} className="mb-3">
                            <Label>Space Applicability</Label>
                            <Select
                                components={{ Input: CustomSelectInput }}
                                className="react-select"
                                classNamePrefix="react-select"
                                isMulti={true}
                                name="form-field-name"
                                value={selectedOptions}
                                onChange={handleChangeMulti}
                                options={spaceList}
                            />
                        </Colxx>
                        <Colxx sm={6} className="mb-3">
                            <Label>Status</Label>
                            <Input
                                type="select"
                                value={addonsData.status}
                                name="status"
                                onChange={handleChange}
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                                <option value="Archived">Archived</option>
                            </Input>
                        </Colxx>
                        <Colxx sm={6} className="mb-3">
                            <Label>Display Order</Label>
                            <Input
                                type="number"
                                value={addonsData.displayOrder}
                                name="displayOrder"
                                onChange={handleChange}
                            >
                            </Input>
                        </Colxx>
                    </Row>
                    <Row>
                        <Colxx md={12}>
                            <Button color="primary" onClick={handleSubmit}>
                                {id === undefined ? "Save" : "Update"}
                            </Button>
                            <Button color="secondary" onClick={toggle} className="ml-2">
                                Cancel
                            </Button>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>);
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale
    };
};

export default injectIntl(connect(mapStateToProps)(AddOnForm));